import { apiService } from "../apiService";
import { parsedToken } from "../storageHelper";
import urlConfig from "../../../config/domain";

let pToken: any = parsedToken(),
	userID = pToken ? pToken.username : null;

//Show quotes
export const AGetQuotesNormal = (callback: CallableFunction, symbol: string) => {
	apiService(
		{
			url: urlConfig.orderPlacement.quote + symbol,
			method: "GET",
			authType: "authtoken",
			appidkey: urlConfig.appidkey
		},
		callback
	);
};

//Show holding of a stock for a client
export const AGetHoldingNormal = (callback: CallableFunction, symbol: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderPlacement.holding + userID + "?sym=" + symbol,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

export const AGetSchemeDetailsMf = (callback: CallableFunction, isin: string, scode: string) => {
	apiService(
		{
			url: urlConfig.orderPlacement.schemeDetailsMf + "?isin=" + isin + "&scode=" + scode,
			method: "GET"
		},
		callback
	);
};

export const AGetSchemeMf = (callback: CallableFunction, scode: string) => {
	apiService(
		{
			url: urlConfig.orderPlacement.schemeMf + scode,
			method: "GET"
		},
		callback
	);
};

export const AGetHoldingMf = (callback: CallableFunction, isin: string) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderPlacement.holdingMf + userID + "/" + isin,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

export const AGetAllHoldingMf = (callback: CallableFunction) => {
	if (pToken && pToken.accType !== "CO") {
		apiService(
			{
				url: urlConfig.orderPlacement.holdingMf + userID,
				method: "GET",
				authType: "authtoken"
			},
			callback
		);
	}
};

//Show quotes
export const AGetQuotesNfo = (callback: CallableFunction, isin: string) => {
	apiService(
		{
			url: urlConfig.orderPlacement.quoteNfo + isin + "/PURCHASE",
			method: "GET",
			authType: "authtoken"
		},
		callback
	);
};

export const AGetQuotesExtraNfo = (callback: CallableFunction, scode: string) => {
	apiService(
		{
			url: urlConfig.orderPlacement.quoteExtraNfo + scode,
			method: "GET",
			authType: "authtoken"
		},
		callback
	);
};
